import React, { Component } from 'react'
import { connect } from 'react-redux'
import Idle from './Idle'
import Login from './Login'
import RideNew from './RideNew'
import MachineSelect from './MachineSelect'
import Modal from './Modal'
import Legal from 'common/components/Legal'
import { clearMachines, getMachines } from '../actions'
import { getLegal, acceptLegal } from 'common/actions'

const mapStateToProps = ({ currentUser, currentLegal, machineConfig, idle }) => {
  return {
    currentUser,
    currentLegal,
    machineConfig,
    idle,
  }
}
const mapDispatchToProps = {
  clearMachines,
  getMachines,
  getLegal,
  acceptLegal
}

// @todo can we rename this component?
class App extends Component {
  componentDidMount () {
    if (this.props.currentUser._id) {
      this.updateMachines()
    }
  }

  acceptLegal = async () => {
    await this.props.acceptLegal(this.props.currentUser._id, this.props.currentLegal._id)
  }

  componentDidUpdate (prevProps) {
    if (this.props.currentUser._id && this.props.currentUser._id !== prevProps.currentUser._id) {
      this.updateMachines()
      this.props.getLegal()
    }
  }

  updateMachines = () => {
    // Get all machines for all groups the user belongs to
    this.props.clearMachines()
    for (let membership of this.props.currentUser.memberships) {
      this.props.getMachines(membership.group)
    }
  }

  render () {
    const { currentUser, currentLegal } = this.props
    let content
    if (this.props.idle) {
      content = <Idle />
    }
    else {
      if (this.props.currentUser._id) {
        if (this.props.machineConfig && this.props.machineConfig.pairedAt) {
          content = <RideNew />
        }
        else {
          content = <MachineSelect />
        }
      }
      else {
        content = <Login />
      }
    }

    return (
      <main className="appWrapper">
        <Modal />
        <Legal currentUser={currentUser} currentLegal={currentLegal} acceptLegal={this.acceptLegal} />
        {content}
      </main>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
